// extracted by mini-css-extract-plugin
export default {"news":"newsSection_news__1b5sj","news__items":"newsSection_news__items__1Wyck","news__item":"newsSection_news__item__X5Cfs","news__data":"newsSection_news__data__GVHkf"};